"use strict";

var processInclude = require("base/util");

$(() => {
    processInclude(require("./storeLocator/statesAndCities"));
    processInclude(require("./storeLocator/storeLocator"));
});
